"use strict";
exports.__esModule = true;
exports.chart_color_green_400 = {
  "name": "--pf-chart-color-green-400",
  "value": "#38812f",
  "var": "var(--pf-chart-color-green-400, #38812f)"
};
exports["default"] = exports.chart_color_green_400;